// extracted by mini-css-extract-plugin
export var emailBlockLink = "_gr-0";